module.exports = __webpack_public_path__ + "img/location-singapore.fcd438c2.jpg";